import { createBrowserClient } from '@supabase/ssr';
import type { SupabaseClient } from '@supabase/supabase-js';

import type { Database } from '@/types/supabase';

function requireEnv(name: string, value: string | undefined): string {
  if (value) return value;
  throw new Error(`Missing required env var: ${name}`);
}

function getBrowserSupabaseEnv() {
  // In the browser bundle, only NEXT_PUBLIC_* values are available.
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL ?? process.env.SUPABASE_URL;
  const anonKey =
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ?? process.env.SUPABASE_ANON_KEY;

  return {
    url: requireEnv('NEXT_PUBLIC_SUPABASE_URL', url),
    anonKey: requireEnv('NEXT_PUBLIC_SUPABASE_ANON_KEY', anonKey),
  };
}

/**
 * Browser/client-side Supabase client.
 * Safe to use in 'use client' components.
 */
export function createClient(): SupabaseClient<Database> {
  const { url, anonKey } = getBrowserSupabaseEnv();
  return createBrowserClient<Database>(url, anonKey);
}
